/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable @typescript-eslint/no-explicit-any */

import { StatusEnumStoreConciliation } from "@/enum/statusConciliation";
import { formatToBRL } from "@/utils/formatToMoney";
import { ColumnDef } from "@tanstack/react-table";
import { format } from "date-fns";
import { useNavigate } from "react-router-dom";
import { ILackOfConciliation } from "src/@types/lack-of-conciliation";
import { DataTableColumnHeader } from "./data-table-column-header";

export function getCellActionByStatus(
  store: ILackOfConciliation,
  navigate: any
) {
  return {
    text: "Conciliar",
    action: () =>
      navigate(
        `/conciliacao/lojas/conciliacao-de-caixa-de-loja/${store.conciliation_id}`, { state: { from: location.pathname } }
      ),
  };
}

export function handleCellStyleByStatus(status: string) {
  const color: Record<string, { label: string; color: string }> = {
    [StatusEnumStoreConciliation.OPENED]: { label: "Aberto", color: "#00AC4F" },
    [StatusEnumStoreConciliation.CLOSED]: {
      label: "Fechado",
      color: "#B3B3B3",
    },
    [StatusEnumStoreConciliation.NOT_INTEGRATED]: {
      label: "Não integrado",
      color: "#79606C",
    },
    [StatusEnumStoreConciliation.PENDING]: {
      label: "Pendente",
      color: "#E3B400",
    },
  };

  return (
    <div
      className="text-right"
      style={{ color: color[status]?.color ?? "#444444" }}
    >
      {color[status]?.label}
    </div>
  );
}

export const columns: ColumnDef<any>[] = [
  {
    accessorKey: "conciliation.store.code",
    header: ({ column }) => (
      <div className="flex justify-center">
        <DataTableColumnHeader column={column} title="Lojas" />
      </div>
    ),
    cell: ({ row }) => (
      <div className="text-center">
        Loja {row.original.conciliation?.store?.code}
      </div>
    ),
  },
  {
    accessorKey: "operator",
    header: ({ column }) => (
      <div className="flex justify-center">
        <DataTableColumnHeader column={column} title="Caixa" />
      </div>
    ),
    cell: ({ row }) => (
      <div className="text-center">
        {row.original.operator}
      </div>
    ),
  },
  {
    accessorKey: "conciliation.date",
    header: ({ column }) => (
      <div className="flex justify-center">
        <DataTableColumnHeader column={column} title="Data" />
      </div>
    ),
    cell: ({ row }) => (
      <div className="text-center">
        {format(new Date(row.original.conciliation?.date), "dd/MM/yyyy")}
      </div>
    ),
  },
  {
    accessorKey: "amount",
    header: ({ column }) => (
      <div className="flex justify-center">
        <DataTableColumnHeader column={column} title="Valor" />
      </div>
    ),
    cell: ({ row }) => (
      <div className="text-center">
        {formatToBRL(Number(row.original.amount))}
      </div>
    ),
  },
  {
    accessorKey: "sla",
    header: ({ column }) => (
      <div className="flex justify-center">
        <DataTableColumnHeader column={column} title="SLA" />
      </div>
    ),
    cell: ({ row }) => (
      <div className="text-center">
        {row.original.sla} Hora(s)
      </div>
    ),
  },
  {
    accessorKey: "conciliation.store.responsible.name",
    header: ({ column }) => (
      <div className="flex justify-center">
        <DataTableColumnHeader column={column} title="Analista Responsável" />
      </div>
    ),
    cell: ({ row }) => (
      <div className="text-center">
        {row.original.conciliation?.store?.responsible?.name ?? "-"}
      </div>
    ),
  },
  {
    accessorKey: "conciliation.store.regional.name",
    header: ({ column }) => (
      <div className="flex justify-center">
        <DataTableColumnHeader column={column} title="Regional" />
      </div>
    ),
    cell: ({ row }) => (
      <div className="text-center">
        {row.original.conciliation?.store?.regional?.name ?? "-"}
      </div>
    ),
  },
  {
    id: "actions",
    header: () => <div> Ações </div>,
    cell: ({ row }: { row: { original: ILackOfConciliation } }) => {
      const store = row.original;
      const navigate = useNavigate();
      return (
        <div className="flex text-center justify-center">
          <button
            onClick={() => getCellActionByStatus(store, navigate).action()}
            className="hover:underline text-[#3c7dd9]"
          >
            {getCellActionByStatus(store, navigate).text}
          </button>
        </div>
      );
    },
  },
];